import FloatingLabelInput from './FloatingLabelInput';
export default FloatingLabelInput;